import VolumeOffIcon from "@mui/icons-material/VolumeOff";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import type { ColumnDef } from "@tanstack/react-table";

import { TestIds } from "@storyboard/web-test-ids/testIds";
import type { DriverRow } from "@/types/driver";
import ColumnHeader from "@/ui/ColumnHeader";
import type { DataTableFeatures } from "@/ui/dataTableFeatures";
import type { ColumnFilterOptions } from ".";
import { columnWidthFloors } from "./columnMinWidth";

function VolumeCell({ driver }: { driver: DriverRow }) {
  const muted = driver.mostRecentVolumeAudible === false;

  if (muted) {
    return (
      <Tooltip title="Device Muted">
        <Box
          data-sb={TestIds.driverView.rowVolumeMuted}
          sx={{
            display: "inline-flex",
            alignItems: "center",
            color: "#ef4444",
          }}
        >
          <VolumeOffIcon sx={{ fontSize: 18 }} />
        </Box>
      </Tooltip>
    );
  }

  if (typeof driver.volume !== "number") return null;

  return <>{Math.round(driver.volume * 100)}%</>;
}

const VOLUME_COLUMN_TITLE = "Device Volume";

export function volumeColumn(options: ColumnFilterOptions): ColumnDef<DataTableFeatures, DriverRow> {
  const { minSize, initialMinWidth } = columnWidthFloors(VOLUME_COLUMN_TITLE, { draggable: true, hasFilter: true });
  return {
    accessorKey: "volume",
    header: () => (
      <ColumnHeader
        title={VOLUME_COLUMN_TITLE}
        extra={options.getColumnExtra("volume")}
        isActive={options.isFilterActive("volume")}
      />
    ),
    cell: ({ row }) => <VolumeCell driver={row.original} />,
    meta: { flex: 1, draggable: true, initialMinWidth },
    minSize,
    enableSorting: false,
    enableGlobalFilter: false,
  };
}
